import React, { useEffect, useState } from 'react';
import './FilterApplications.styles.scss'
import EastIcon from '@mui/icons-material/East';
import Typography from '@mui/material/Typography';
import useTranslation from '../../translations/use-translation';
import GeneralDialog from '../common/GeneralDialog/GeneralDialog.component';
import StateList from '../common/StateList/StateList.component';

const filterHeadingSx = { color: 'secondary.contrastText' };
const categoryHeaderSx = { color: 'common.white' };
const forwardIconSx = { color: 'common.white' };

const FilterApplications = ({ applicationCardListContainerRef, currentSelectedOptionForService, setCurrentSelectedOptionForService }) => {
  const [openStateListDialog, setOpenStateListDialog] = useState(false);
  const translate = useTranslation();

  const scrollToResults = () => {
    applicationCardListContainerRef?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleServiceCategoryState = () => {
    setOpenStateListDialog(true);
  };

  const handleServiceCategoryQualification = () => {
    setCurrentSelectedOptionForService({ category: 'qualification', value: '' });
    scrollToResults();
  };

  const handleServiceCategoryPopular = () => {
    setCurrentSelectedOptionForService({ category: 'popular-category', value: '' });
    scrollToResults();
  };

  const handleServiceCategoryCommon = () => {
    setCurrentSelectedOptionForService({ category: 'common-services', value: '' });
    scrollToResults();
  };

  useEffect(() => {
    if (currentSelectedOptionForService.value?.length) {
      setOpenStateListDialog(false);
      scrollToResults();
    }
  }, [currentSelectedOptionForService]);
  return (
    <>
      <Typography className='oa-service-filter-heading' variant="h6" sx={filterHeadingSx}>{translate('FILTER_APP_HEADING')}</Typography>
      <div className={'oa-filter-applications'}>
        <div className='oa-service-category-state' onClick={handleServiceCategoryState}>
          <Typography className='oa-service-category-text-header' sx={categoryHeaderSx}> {translate('FILTER_APP_STATE_HEADING')} </Typography>
          <Typography className='oa-service-category-text-header-description'> {translate('FILTER_APP_STATE_HEADING_DESC')}  </Typography>
          <div className='oa-service-category-text-header-forward'>  <EastIcon sx={forwardIconSx} /> </div>
        </div>
        <div className='oa-service-category-qualification' onClick={handleServiceCategoryQualification}>
          <Typography className='oa-service-category-text-header' sx={categoryHeaderSx}> {translate('FILTER_APP_QUALIFICATION_HEADING')} </Typography>
          <Typography className='oa-service-category-text-header-description'>{translate('FILTER_APP_QUALIFICATION_HEADING_DESC')}</Typography>
          <div className='oa-service-category-text-header-forward'>  <EastIcon sx={forwardIconSx} /> </div>
        </div>
        <div className='oa-service-category-category' onClick={handleServiceCategoryPopular}>
          <Typography className='oa-service-category-text-header' sx={categoryHeaderSx}> {translate('FILTER_APP_POPULAR_CATEGORIES_HEADING')} </Typography>
          <Typography className='oa-service-category-text-header-description'> {translate('FILTER_APP_POPULAR_CATEGORIES_HEADING_DESC')}</Typography>
          <div className='oa-service-category-text-header-forward'>  <EastIcon sx={forwardIconSx} /> </div>
        </div>
        <div className='oa-service-category-common-services' onClick={handleServiceCategoryCommon}>
          <Typography className='oa-service-category-text-header' sx={categoryHeaderSx}> {translate('FILTER_APP_COMMON_SERVICE_HEADING')} </Typography>
          <Typography className='oa-service-category-text-header-description'>  {translate('FILTER_APP_COMMON_SERVICE_HEADING_DESC')} </Typography>
          <div className='oa-service-category-text-header-forward'>  <EastIcon sx={forwardIconSx} /> </div>
        </div>
        {
          <GeneralDialog
            openDialog={openStateListDialog}
            setOpenDialog={setOpenStateListDialog}
            dialogHeader={translate('SELECT_STATE_DIALOG_HEADER')}
            dialogBody={<StateList setCurrentSelectedState={setCurrentSelectedOptionForService} />
            }
          />
        }
      </div>
    </>
  );
}
export default FilterApplications;